import produce from "immer";
import { IAutomationState, IGraphNode } from "./automation.types";
import { getUniqueId } from "../../helpers";

export const updateNodesWithPlaceholderAndEdges = (state: IAutomationState, node: IGraphNode, isDelete: boolean ) =>{
    const newState = produce(state, draftState=>{
        const index = draftState.graphData.nodes.findIndex(x=>x.id === node.id);
        if(isDelete){
         
            if(index > -1){
                // Find edges where this node is the source or target
                const incomingEdge = draftState.graphData.edges.find(edge => edge.target === node.id);
                const outgoingEdges = draftState.graphData.edges.filter(edge => edge.source === node.id);
                
                // Remove the node
                draftState.graphData.nodes.splice(index, 1);
                
                // Remove edges connected to deleted node
                draftState.graphData.edges = draftState.graphData.edges.filter(
                    edge => edge.source !== node.id && edge.target !== node.id
                );
                
                // Reconnect the graph: if the deleted node had both incoming and outgoing edges,
                // connect the source of the incoming edge to the targets of the outgoing edges
                if(incomingEdge && outgoingEdges.length > 0){
                    outgoingEdges.forEach(outgoingEdge => {
                        const edgeId = `${incomingEdge.source}=>${outgoingEdge.target}`;
                        // Only add if not already exists
                        if (!draftState.graphData.edges.some(e => e.id === edgeId)) {
                            draftState.graphData.edges.push({
                                id: edgeId,
                                source: incomingEdge.source,
                                target: outgoingEdge.target,
                                type: outgoingEdge.type,
                            });
                        }
                    });
                }
            }
        }
        else if(index > -1){
            // Node exists, just update its data
            draftState.graphData.nodes[index] = {
                ...draftState.graphData.nodes[index],
                data: node.data,
            };
            // Don't touch edges when updating existing node
        }
        else {
            // Adding a new node
            const placeholderNodeId = getUniqueId();
          
            draftState.graphData.nodes.push(node);
            const placeholderNodeIndex = draftState.graphData.nodes.findIndex(x=>x.type === "placeholder");
            if(placeholderNodeIndex > -1){
                draftState.graphData.nodes.splice(placeholderNodeIndex, 1);
            }
            draftState.graphData.nodes.push({
                id: placeholderNodeId,
                position: { x: 0, y:0 },
                type: 'placeholder',
                data: { label: '+',payload: {} as any },
            });

            // Preserve existing edges (branching edges)
            const existingEdges = [...draftState.graphData.edges];
            
            // Clear edges only if we need to rebuild the main flow
            draftState.graphData.edges = [];
            
            // First, add back all branching edges (edges from action nodes to finish nodes)
            const branchingEdges = existingEdges.filter(edge => {
                const sourceNode = draftState.graphData.nodes.find(n => n.id === edge.source);
                const targetNode = draftState.graphData.nodes.find(n => n.id === edge.target);
                return sourceNode?.type?.includes('actionNode') && 
                       (targetNode?.type === 'performEmailAction' || targetNode?.type === 'placeholder');
            });
            
            draftState.graphData.edges.push(...branchingEdges);
            
            // Get all nodes that are part of the main vertical flow (not branching targets)
            const branchingTargetIds = new Set(branchingEdges.map(e => e.target));
            const mainFlowNodes = draftState.graphData.nodes.filter(n => !branchingTargetIds.has(n.id));

            // Rebuild the main vertical flow edges
            for (let i = 0; i < mainFlowNodes.length; i++) {
                if (i !== 0) {
                    const targetId = mainFlowNodes[i].id;
                    const sourceId = mainFlowNodes[i - 1].id;
                    const edgeId = `${sourceId}=>${targetId}`;
                    
                    // Only add if not already exists
                    if (!draftState.graphData.edges.some(e => e.id === edgeId)) {
                        draftState.graphData.edges.push({
                            id: edgeId,
                            source: sourceId,
                            target: targetId,
                            type: mainFlowNodes[i].type,
                        });
                    }
                }
            }
        }
    });
    return newState;
}